module.exports = __webpack_public_path__ + "lato-light-webfont.8c123c0109c1ae914ea9.woff2";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/fonts/lato-light-webfont.woff2
// module id = ../../../../../resources/fonts/lato-light-webfont.woff2
// module chunks = styles